<!-- @format -->

<!-- Certona Recommendations -->
<div
	*ngIf="certonaRecommendationsResponse"
	class="row no-gutters">
	<div
		id="category_rr"
		class="col-12 hmf-mt-s recently-viewed">
		<clp-certona-recommendations
			class="category_rr"
			[productRecommendations]="certonaRecommendationsResponse"
			[displayName]="'Recently Viewed'"
			[filterBy]="'category_rr'"
			[showViewMoreLink]="false"
			[viewAllText]="'View All >'"
			[productDisplayLimit]="10">
		</clp-certona-recommendations>
	</div>
</div>

<div
	*ngIf="seoResponse?.seoUrl"
	class="protips-container">
	<shared-component-pro-tips [category]="seoResponse.seoUrl"></shared-component-pro-tips>
</div>

<clp-searchdex
	*ngIf="['dsg', 'gg'].includes(chainAbbr) && searchDexResponse"
	[data]="searchDexResponse"></clp-searchdex>
